import { AppInitializer } from "./app-initializer";

// Skip in test: AppInitializer uses angular.injector(['ng']) which triggers ngLocale and
// conflicts with angular-mocks' $$annotate wrapper (stack overflow).
// Specs use angular.mock.module('BookingApp') instead.
if (typeof window !== "undefined" && (window as any).__KALIGO_TEST__) {
  // no-op
} else {
  const appInitalizer = new AppInitializer();

  appInitalizer.initializeApp()
    .then(() => {
      angular.element(document).ready(() => {
        angular.bootstrap(document.documentElement, ["BookingApp"]);
      });
    });
}
